import { SocialNetworkData } from "../../lib/social";
import { MagicLink } from "../../ui";
import { FacebookIcon } from "./FacebookIcon.component";
import { InstagramIcon } from "./InstagramIcon.component";
import { SnapchatIcon } from "./SnapchatIcon.component";
import "./SocialIcons.style.scss";
import { TiktokIcon } from "./TiktokIcon.component";
import { TwitterIcon } from "./TwitterIcon.component";
import { YoutubeIcon } from "./YoutubeIcon.component";

interface SocialIconsProps {
  networks: SocialNetworkData[];
  customIcons?: { [provider: string]: JSX.Element };
}

interface SocialNetworkMap {
  [provider: string]: {
    url: (name: string) => string;
    icon: JSX.Element;
  };
}

const networkInfo: SocialNetworkMap = {
  facebook: {
    url: name => `//www.facebook.com/${name}`,
    icon: <FacebookIcon />,
  },
  twitter: {
    url: name => `//www.twitter.com/${name}`,
    icon: <TwitterIcon />,
  },
  instagram: {
    url: name => `//www.instagram.com/${name}`,
    icon: <InstagramIcon />,
  },
  youtube: {
    url: name => `//www.youtube.com/${name}`,
    icon: <YoutubeIcon />,
  },
  snapchat: {
    url: name => `//www.snapchat.com/add/${name}`,
    icon: <SnapchatIcon />,
  },
  tiktok: {
    url: name => `//www.tiktok.com/@${name}`,
    icon: <TiktokIcon />,
  },
};

export const SocialIcons = (props: SocialIconsProps) => (
  <ul className="component-social-icons">
    {props.networks.map((network, index) =>
      networkInfo[network.network] ? (
        <li className="icon-container" key={index}>
          <MagicLink
            to={networkInfo[network.network].url(network.username)}
            aria-label={`Visit us on ${network.network}`}
            target="_blank"
          >
            {props.customIcons?.[network.network] || networkInfo[network.network].icon}
          </MagicLink>
        </li>
      ) : null,
    )}
  </ul>
);
